export default import.meta.ROLLDOWN_FILE_URL_bAqdHKP_xRyIHOmkTRuOfQ